import { render, staticRenderFns } from "./allowDragSortTable.vue?vue&type=template&id=566ed4e0&scoped=true"
import script from "./allowDragSortTable.vue?vue&type=script&lang=js"
export * from "./allowDragSortTable.vue?vue&type=script&lang=js"
import style0 from "./allowDragSortTable.vue?vue&type=style&index=0&id=566ed4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ed4e0",
  null
  
)

export default component.exports